var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blog-section", class: _vm.bgColor }, [
    _vm.blogSectionType === "articles"
      ? _c(
          "div",
          { staticClass: "blog-section-articles" },
          [
            _vm.featuredArticles.articles.length <= 4
              ? _c("blog-section-articles-static", {
                  attrs: { "featured-articles": _vm.featuredArticles }
                })
              : _vm._e(),
            _vm.featuredArticles.articles.length > 4
              ? _c("blog-section-articles-carousel", {
                  attrs: { "featured-articles": _vm.featuredArticles }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm.blogSectionType === "categories"
      ? _c(
          "div",
          { staticClass: "blog-section-categories" },
          [
            _vm.featuredCategories.layout === "static"
              ? _c("blog-section-categories-static", {
                  attrs: { "featured-categories": _vm.featuredCategories }
                })
              : _vm._e(),
            _vm.featuredCategories.layout === "carousel"
              ? _c("blog-section-categories-carousel", {
                  attrs: { "featured-categories": _vm.featuredCategories }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }